<template>
  <div class="h-full overflow-hidden">
    <el-table
      :data="incomingThreeTrainingData"
      border
      stripe
      class="mt-20px"
      :height="tableHeight"
      v-loading="loading"
    >
      <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
      <el-table-column label="培训时间" prop="trainingDateEnd" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ dayjs(scope.row.trainingDateEnd).format('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column label="培训地点" prop="place" show-overflow-tooltip></el-table-column>
      <el-table-column label="培训人员" prop="userName" show-overflow-tooltip></el-table-column>
      <el-table-column label="培训内容" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="考试成绩" prop="statusName" show-overflow-tooltip></el-table-column>
      <el-table-column
        label="培训老师"
        prop="publisherName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button size="mini">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="incomingThreeTrainingTableSizeChange"
      @current-change="incomingThreeTrainingableCurrentChange"
      :current-page.sync="incomingThreeTrainingPageConfig.SkipCount"
      :page-size.sync="incomingThreeTrainingPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="incomingThreeTrainingPageConfig.total"
      class="float-right mt-20px ml-20px clear-both"
    ></el-pagination>
  </div>
</template>
<script>
import { TrainingRecordApi } from '@wiz-api/training-management'

const trainingRecordApi = new TrainingRecordApi()
export default {
  data() {
    return {
      loading: false,
      incomingThreeTrainingData: [],
      incomingThreeTrainingPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
        total: 0,
      },
    }
  },
  props: {
    orgId: {
      type: String,
      default: '',
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 75px)'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    // 奖励考核信息页码改变
    incomingThreeTrainingTableSizeChange(MaxResultCount) {
      this.rewardsAndAssessment.MaxResultCount = MaxResultCount
      this.getData()
    },
    // 奖励考核信息页数改变
    incomingThreeTrainingableCurrentChange(SkipCount) {
      this.rewardsAndAssessmentPageConfig.SkipCount = SkipCount
      this.getData()
    },
    async getData() {
      if (!this.orgId) {
        this.$message.error('当前用户未绑定组织机构')
        return
      }
      const data = {
        maxResultCount: this.incomingThreeTrainingPageConfig.MaxResultCount, // 每页多少条
        skipCount:
          (this.incomingThreeTrainingPageConfig.SkipCount - 1) *
          this.incomingThreeTrainingPageConfig.MaxResultCount, // 跳过多少条
        organizationUnitIds: [this.orgId],
      }
      this.loading = true
      const [err, res] = await trainingRecordApi.getList(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.loading = false
    },
  },
}
</script>
